function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "backspace_24px"
}, React.createElement("path", {
  id: "icon/content/backspace_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.8975 3H21.8975C22.9975 3 23.8975 3.89999 23.8975 5V19C23.8975 20.1 22.9975 21 21.8975 21H6.8975C6.2075 21 5.6675 20.64 5.3075 20.12L0.267502 12.56C0.0475006 12.22 0.0475006 11.79 0.267502 11.45L5.3075 3.88C5.6675 3.35001 6.2075 3 6.8975 3ZM16.7875 16.3C17.1775 16.69 17.8075 16.69 18.1975 16.3C18.5775 15.91 18.5775 15.27 18.1975 14.89L15.3075 12L18.1975 9.11002C18.5875 8.72 18.5875 8.09 18.1975 7.70001C17.8075 7.31 17.1775 7.31 16.7875 7.70001L13.8975 10.59L11.0075 7.70001C10.6175 7.31 9.9875 7.31 9.5975 7.70001C9.41025 7.88684 9.30502 8.14047 9.30502 8.405C9.30502 8.66953 9.41025 8.92316 9.5975 9.11002L12.4875 12L9.5975 14.89C9.41025 15.0768 9.30502 15.3305 9.30502 15.595C9.30502 15.8595 9.41025 16.1132 9.5975 16.3C9.9875 16.69 10.6175 16.69 11.0075 16.3L13.8975 13.41L16.7875 16.3Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgSekatKanal = function SvgSekatKanal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSekatKanal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sekat_kanal.2f0e040e.svg";
export { ForwardRef as ReactComponent };